module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"send":"Отправить","errors":{"connection":"Невозможно отправить сейчас, попробуйте позже.","message":{"required":"Нельзя отправить пустое сообщение","string":"В сообщении нельзя писать загадочные символы","min":"Сообщение должно быть хотя бы из двух букв"}}}}')
  delete Component.options._Ctor
}
